import React from 'react'
import { Modal,Button} from 'react-bootstrap';
import PropTypes from 'prop-types'

const Notification = props => {
    const {IsSuccess, handleClose, title, msgList} = props;
    console.log("msgList",msgList)
  return (
    <div>
         <Modal show={IsSuccess} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        {/* <Modal.Body>{message}</Modal.Body> */}
        <Modal.Body>
          {
            msgList.map((item) => {
            return  <p>{item}</p>
            })
          }
        </Modal.Body>
        <Modal.Footer style={{ display: "flex", justifyContent: "space-between" }}>
          <label>Thank you for showing interest for CTG</label>
          <Button variant="success" onClick={handleClose}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

Notification.propTypes = {}

export default Notification